<template lang="pug">
.grid.bg-white.py-4.border-t.border-b.border-gray-100.grid-cols-1(class="px-4 md:px-0 md:grid-cols-2 md:items-center")
  u-button(
    variant="success"
    block
    class="md:col-start-2"
    @click="$emit('send')"
    :disabled="sendDisabled"
  )
    | Отправить заявку
    u-icon(right icon="mdi-arrow-right")
</template>

<script>
export default {
  props: {
    model: { type: Object, default: () => ({}) }
  },

  computed: {
    sendDisabled() {
      return !Object.values(this.model).length;
    }
  }
};
</script>
